<template>
    <div class="w100 pl10 pr10 pt10 pb10 flex-box label">
        <div class="mr20 flex-box flex-col label-left bor">
           <leftLabelList ref="leftLabelList" @leftLabelClick="leftLabelClick"/>
        </div>

        <div class="flex-1 w100 h100 label-right bor"  >
            <el-collapse-transition>
                <component :is="curComp"
                           @saveSuccess="saveSuccess"
                           @openDetail="openDetail"
                           ref="curCompRef"
                           @goBack="goBack">
                </component>
             </el-collapse-transition>
        </div>
    </div>
</template>

<script>
    import leftLabelList from "@/components/management/label/leftLabelList";
    import addLabel from "@/components/management/label/addLabel";
    import editLabel from "@/components/management/label/editLabel";
    import memberList from "@/components/management/label/memberList";
    export default {
        name: "Label",
        components: {
            leftLabelList,
            addLabel,
            editLabel,
            memberList
        },
        props: [],
        data() {
            return {
                curComp:'memberList'
            }
        },
        computed: {

        },
        mounted() {},
        methods: {
            saveSuccess(){
                this.$refs.leftLabelList.getLabelListFn();
            },
            leftLabelClick(type,item){

                switch(type) {
                    case 'addLabel':
                        this.curComp=type;

                        break;
                    case 'editLabel':
                        this.curComp=type;
                        this.$nextTick(()=>{
                            this.$refs.curCompRef.setId(item.labelId);
                        })

                        break;
                    case 'del':

                        break;
                    case 'memberList':
                        this.curComp=type;
                        this.$nextTick(()=>{
                            this.$refs.curCompRef.loadListFn(item);
                        })
                        break;
                    default:
                }
            },
            goBack(item){
                this.curComp='memberList';
                this.$nextTick(()=>{
                    this.$refs.curCompRef.loadListFn(item);
                })
            },
            openDetail(labelId){
                this.curComp='editLabel';
                this.$nextTick(()=>{
                    this.$refs.curCompRef.setId(labelId);
                })

            }

        },
        watch: {

        },
        filters: {}
    };
</script>

<style scoped lang="less">
.label{
    &-left{
        width: 300px;
    }
    &-right{
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

}
</style>
